import React from 'react';
import Impl from 'react-svg-spinner';
import { Colors, toRem } from './../../ui';

export type DeprecatedSpinnerProps = {
    color?: string,
    size?: string | number,
};

export const DeprecatedSpinner = ({ color, size }: DeprecatedSpinnerProps) =>
    <Impl color={color ?? Colors.text} size={toRem(size || '1.2')} />;
